import { createSelector } from 'reselect'

const codeList = (list, options) => ({ list, options })

const mapForDropdown = ({ list }) => {
  return list && Array.isArray(list)
    ? list.map(item => ({
        label: item.textTranslated,
        value: item.value
      }))
    : []
}

export default createSelector(codeList, mapForDropdown)
